"use strict";

exports.__esModule = true;
exports.TreeViewWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _TreeViewElement = require("./TreeViewElement");
var _TreeViewFields = require("./TreeViewFields");
var _TreeViewHeader = require("./TreeViewHeader");
var _TreeViewThumbnail = require("./TreeViewThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TreeViewWidget = exports.TreeViewWidget = {
  name: "TreeView",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TreeViewWidget.label",
    defaultMessage: "Tree View"
  }),
  icon: "list",
  createElement: function createElement(props) {
    return {
      type: "TreeView",
      props: Object.assign({
        width: 200,
        height: 150
      }, props),
      children: []
    };
  },
  // TODO: Make this false
  showInPalette: true,
  isParent: false,
  // Hierarchy context is expected to have path and name.
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 200,
      min: 128,
      max: 3840
    },
    height: {
      "default": 150,
      min: 256,
      max: 2160
    }
  },
  components: {
    Header: _TreeViewHeader.TreeViewHeader,
    Element: _TreeViewElement.TreeViewElement,
    Fields: _TreeViewFields.TreeViewFields,
    Thumbnail: _TreeViewThumbnail.TreeViewThumbnail
  }
};